import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { TolisDialogRef } from '../tolis-dialog/tolis-dialogref';
import { DIALOG_DATA } from '../tolis-dialog/tolis-dialog-tokens';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { mxvAnimations } from 'src/@tolis/animations';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-forgot-password.dialog',
  templateUrl: './forgot-password.dialog.component.html',
  styleUrl: './forgot-password.dialog.component.css',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  animations: mxvAnimations,
})
export class ForgotPasswordDialog implements OnInit, OnDestroy {
  _unsubscribeAll: Subject<void> = new Subject();
  forgotPasswordForm: UntypedFormGroup;
  working = false;
  sent = false;
  message = '';

  constructor(
    private _dialogRef: TolisDialogRef,
    @Inject(DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    private _authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      email: [this.data?.email ?? '', [Validators.required, Validators.email]],
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onSubmit(event) {
    event?.preventDefault();
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.working = true;
    this.message = '';

    this._authService
      .requestResetLink(this.forgotPasswordForm.get('email').value)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: () => {
          this.working = false;
          this.sent = true;
        },
        error: (err) => {
          this.working = false;
          this.message =
            err?.error?.error ?? 'Something went wrong, please try again.';
        },
      });
  }

  dismiss() {
    this._dialogRef.close('x');
  }
}
